import { render, staticRenderFns } from "./Hezuo.vue?vue&type=template&id=4b4e35a4&scoped=true&"
import script from "./Hezuo.vue?vue&type=script&lang=js&"
export * from "./Hezuo.vue?vue&type=script&lang=js&"
import style0 from "./Hezuo.vue?vue&type=style&index=0&id=4b4e35a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e35a4",
  null
  
)

export default component.exports